import React from "react";
import Select from "react-select";
import useCustomTheme from "../../../hooks/useCustomTheme";


const CustomReactSelect = (props) => {

    const { customReactSelectStyles } = useCustomTheme();

  return (
    <Select
      {...props}
      className="AlternatiVSelect"
      styles={customReactSelectStyles}
      menuPlacement="auto"
      isClearable
    />
  );
};

export default CustomReactSelect;
